var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1:6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 20.929C18.7213 20.929 20.9269 18.7233 20.9269 16.0025C20.9269 13.2817 18.7213 11.0761 16.0005 11.0761C13.2797 11.0761 11.074 13.2817 11.074 16.0025C11.074 18.7233 13.2797 20.929 16.0005 20.929Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5097 14.6383C27.7228 10.0622 21.9906 5.65733 16.0006 5.65733C10.0094 5.65733 4.27576 10.0653 0.491442 14.6383C-0.163162 15.429 -0.163162 16.5768 0.491442 17.3675C1.44286 18.5172 3.43746 20.7366 6.10145 22.6758C12.8106 27.5599 19.1757 27.5707 25.8997 22.6758C28.5636 20.7366 30.5582 18.5172 31.5097 17.3675C32.1624 16.5784 32.1657 15.4316 31.5097 14.6383V14.6383ZM16.0006 9.10585C19.8038 9.10585 22.8976 12.1997 22.8976 16.0029C22.8976 19.8061 19.8038 22.8999 16.0006 22.8999C12.1973 22.8999 9.10351 19.8061 9.10351 16.0029C9.10351 12.1997 12.1973 9.10585 16.0006 9.10585Z",
    fill: "#838383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1:6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d8222b87.svg";
export { ForwardRef as ReactComponent };